import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
import { BackButton } from "../../../../Components/Utils/Buttons";
import Equipment from "./Equipments";
import Vehicle from "./Vehicles";


  
  
  const MainMaintenanceSettings = () =>{
    return(
      <div className='w-full h-full px-4 py-2'>
        <div className='w-full flex justify-between items-center'>
        <Breadcrumb
          items={[
            {
              name: "Settings",
            },
            {
              name: "Maintenance"
            }
          ]}
        />
        <BackButton/>
        </div>
        <div className="w-full h-[calc(100vh-145px)] bg-white mt-3 mx-auto rounded-md overflow-y-scroll">
            <div className="p-3"><Vehicle/></div>
            <div className="p-3"><Equipment/></div>
        </div>
        </div>
    )
  }

  export default MainMaintenanceSettings;